import { styled } from '@mui/system'
import { Head, Desc } from 'Components/Typography/Text.styles'
import { BORDER_RADIUSES, colors, fontSizes } from 'Components/consts'
import { Img } from 'Components/Image'

export const TrackerOuter = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
}))
export const TrackerContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: theme.spacing(4),
  borderRadius: BORDER_RADIUSES.large,
  width: '80%',
  margin: 'auto',
  textAlign: 'center',
  border: `1px solid ${colors.gray.gray20}`,
  boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
  position: 'relative',
  overflow: 'hidden',
  backgroundImage: `linear-gradient(rgba(255, 255, 255, 0.8), rgba(255, 255, 255, 0.8)), url(https://premierlacrosseleague.com/wp-content/uploads/2025/07/redwoods-assist-background.webp)`,
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  backgroundRepeat: 'no-repeat',
  [theme.breakpoints.down('sm')]: {
    width: '100%',
  },
}))

export const ContentWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'center',
  alignItems: 'center',
  gap: theme.spacing(3),
  width: '100%',
  marginBottom: theme.spacing(3),
}))

export const SponsorsContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  gap: theme.spacing(2),
}))

export const SponsorLogo = styled(Img)({
  height: 'auto',
  width: '100%',
  maxWidth: '450px',
  objectFit: 'contain',
})

export const StatsContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  gap: theme.spacing(3),
  [theme.breakpoints.down('sm')]: {
    width: '50%',
  },
}))

export const StatBox = styled('div')(({ theme }) => ({
  border: `2px solid ${colors.darkGreen}`,
  borderRadius: BORDER_RADIUSES.medium,
  padding: theme.spacing(2, 4),
  flex: 1,
  minWidth: 200,
  textAlign: 'center',
  [theme.breakpoints.down('sm')]: {
    minWidth: 100,
  },
}))

export const StatValue = styled(Head, {
  shouldForwardProp: (prop) => prop !== 'role',
})<{}>(({ theme }) => ({
  fontSize: fontSizes.large,
  fontWeight: 'bold',
  color: colors.darkGreen,
  lineHeight: 1.2,
}))

export const StatLabel = styled(Desc)(({ theme }) => ({
  fontSize: fontSizes.medium,
  color: colors.darkGreen,
  opacity: 0.9,
}))

export const Description = styled(Desc)(({ theme }) => ({
  textAlign: 'center',
  margin: theme.spacing(3),
  color: colors.gray.gray80,
  [theme.breakpoints.down('sm')]: {
    fontSize: fontSizes.xSmall,
  },
}))
